// extracted by mini-css-extract-plugin
module.exports = {"list":"works_list_11jLd","item":"works_item_3R5vT","title":"works_title_1J8Yi","link":"works_link_t2suY","contact":"works_contact_3efqj"};